import { formatNumber, splitByCaps } from "~/utils/miscUtils";

export const processTemplateSyntaxSugar = (
  otherAnswer: string,
  adjustments: any, // TODO: determine type?
) => {
  let joiner = " ";
  const arr: string[] = adjustments.reduce(
    (acc: string | string[], adjustment: string) => {
      if (typeof acc === "string") {
        acc = [acc];
      }
      switch (adjustment?.toLowerCase()) {
        case "uppercase":
          return acc.map((s: string) => s.toUpperCase());
        case "lowercase":
          return acc.map((s: string) => s.toLowerCase());
        case "capitalize":
          // capitalize the first letter of each word
          return acc.map((s: string) =>
            s.replaceAll(/\b\w/g, (c: string) => c.toUpperCase()),
          );
        case "formatdollar":
        case "formatdollars":
          return acc.map((s: string) => "$" + formatNumber(s));
        case "formatwholenumber":
          return acc.map((s: string) => formatNumber(s, 0));
        case "splitbycaps":
          return acc.map((s) => splitByCaps(s));
        case "breaklist":
          // convert comma separated list to an array
          joiner = "<br>";
          return acc[0].split(",");
        default:
          if (adjustment.includes("_")) {
            return acc.map((s: string) => adjustment.replaceAll("_", s));
          }
          return acc;
      }
    },
    otherAnswer,
  );
  return arr.join(joiner);
};
